export enum PrintTaskType {
  Receipt = 0,
  Ticket = 1,
  CreditCardReceipt = 2,
  RFIDCardReceipt = 3,
  IssueReceipt = 4,
}
